
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#7C7C7C","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.136 12.864a5.728 5.728 0 10-.002-11.456 5.728 5.728 0 00.003 11.456z"}}),_c('path',{attrs:{"d":"M7.136 7.955a.819.819 0 100-1.638.819.819 0 000 1.638zm0-1.637V3.455m.579 4.26l1.467 1.466"}})])])
          )
        }
      }
    